var _defs, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.17 71.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.59,
    cy: 35.59,
    r: 35.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.94,183.48c0-5.42,0-10.74,0-16.06a3.87,3.87,0,0,1,3.8-3.88c.85,0,1.71,0,2.56,0s1.05.33,1,1.08,0,1.27,0,1.91a3.91,3.91,0,0,0,3.91,3.9c2.84.12,4.6-1.14,4.87-3.54a17.63,17.63,0,0,0,0-2.3c0-.75.25-1.06,1-1.06,2.94,0,5.88,0,8.82,0,.72,0,1,.29,1,1s0,1.36,0,2a3.88,3.88,0,0,0,3.93,3.86c2.85.11,4.61-1.2,4.84-3.58,0-.34,0-.68,0-1,0-2.65-.15-2.25,2.24-2.28.42,0,.85,0,1.28,0a3.82,3.82,0,0,1,3.82,3.83q.06,14.82,0,29.64a3.71,3.71,0,0,1-3.78,3.84c-6.18,0-12.36,0-18.53,0a1.61,1.61,0,0,1-.37-.07c.36-1.85.36-1.85,2.14-1.85h15.84c2.21,0,2.79-.59,2.79-2.83,0-6.43,0-12.86,0-19.29,0-1.17-.33-1.53-1.52-1.53q-18.13.08-36.28,0c-1.26,0-1.64.38-1.55,1.6s-.1,2.65.05,4C230.14,182.37,229.43,183.09,227.94,183.48Z",
    transform: "translate(-212.02 -146.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.82,206.76A11.78,11.78,0,1,1,247.6,195,11.69,11.69,0,0,1,235.82,206.76ZM244.63,195a8.85,8.85,0,0,0-17.69,0,8.85,8.85,0,1,0,17.69,0Z",
    transform: "translate(-212.02 -146.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.81,164.46c0-.64,0-1.28,0-1.92a2.68,2.68,0,0,1,2.83-2.91,2.76,2.76,0,0,1,3.06,2.84c0,1.36,0,2.73,0,4.09a2.77,2.77,0,0,1-3,2.86,2.7,2.7,0,0,1-2.84-2.92C236.8,165.82,236.81,165.14,236.81,164.46Z",
    transform: "translate(-212.02 -146.29)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.47,164.48c0-.72,0-1.44,0-2.16a2.64,2.64,0,0,1,2.51-2.68c1.78-.15,3.13.66,3.28,2.25a27.81,27.81,0,0,1,0,5.32c-.15,1.53-1.48,2.32-3.2,2.2a2.64,2.64,0,0,1-2.56-2.64C256.44,166,256.47,165.25,256.47,164.48Z",
    transform: "translate(-212.02 -146.29)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.32,194.48h3.16c1,0,1.69.44,1.7,1.48s-.7,1.49-1.68,1.5c-1.49,0-3,0-4.46,0a1.57,1.57,0,0,1-1.71-1.77c0-1.79,0-3.57,0-5.35,0-1,.45-1.71,1.48-1.72s1.49.7,1.5,1.69C236.33,191.65,236.32,193,236.32,194.48Z",
    transform: "translate(-212.02 -146.29)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIns);
export default __webpack_public_path__ + "static/media/check_ins.7355897cedd708fbfd8570b3c06b8044.svg";
export { ForwardRef as ReactComponent };